import { IPRNABCState } from '../store/pcr.types'
import { neuroPrNabc } from '../../initialAssessments/neuro/store/neuro.reducers'
import { initialAirwayNabc } from '../../initialAssessments/airway/store/airway.reducers'
import { respiratoryStatePrNabc } from '../../initialAssessments/respiratory/store/respiratory.reducers'
import { initialCardioNabc } from '../../initialAssessments/cardio/store/cardio.reducers'
import { wasPatientImmobilizedPrNabc } from '../../initialAssessments/neuro/wasPatientImmobilized/store/wasPatientImmobilized.reducers'
import { glassgowCommaScorePrNabc } from '../../initialAssessments/neuro/glassgowCommaScore/store/glassgowCommaScore.reducers'
import { initialMotorSensoryAssessmentState } from '../../initialAssessments/neuro/motorSensoryAssessment/store/motoSensoryAssessment.reducers'
import { initialPediatricTraumaScoreState } from '../../initialAssessments/neuro/pediatricTraumaScore/store/pediatricTraumaScore.reducers'
import { initialPupilsState } from '../../initialAssessments/neuro/pupils/store/pupils.reducers'
import { initialRevisedTraumaScoreState } from '../../initialAssessments/neuro/revisedTraumaScore/store/revisedTraumaScore.reducers'
import { initialPulsesState } from '../../initialAssessments/cardio/pulses/store/pulses.reducer'

export const prNabc: IPRNABCState = {
  ...neuroPrNabc,
  ...initialAirwayNabc,
  ...respiratoryStatePrNabc,
  ...initialCardioNabc,
  ...wasPatientImmobilizedPrNabc,
  ...glassgowCommaScorePrNabc,
  ...initialMotorSensoryAssessmentState,
  ...initialPediatricTraumaScoreState,
  ...initialPupilsState,
  ...initialRevisedTraumaScoreState,
  ...initialPulsesState,
}
